import axios from '../axios-on-rails';

class MemberRecommendationSearch {
  getSearchSessionId() {
    const url = new URLSearchParams(window.location.search);
    return url.get('searchsession');
  }

  getResultId() {
    const url = new URLSearchParams(window.location.search);
    return url.get('result_id');
  }

  toggleCheckAll(target, displayIgnored) {
    const checked = $(target).prop('checked');
    const endpoint = Routes[`${checked ? '' : 'un'}check_all_member_recommendation_search_index_path`];
    axios({
      method: checked ? 'post' : 'delete',
      url: endpoint(gon.locale),
      data: {
        format: gon.locale,
        q: { display_ignored: displayIgnored },
        searchsession: this.getSearchSessionId(),
        result_id: this.getResultId()
      }
    }).then(res => {
      if (res.status == 200) {
        $('.js-checkbox-jobfolder').prop('checked', checked);
        $('.js-checkbox-all').prop('checked', res.data.all_members_checked);
      }
    });
  }

  checkboxOne(target, displayIgnored) {
    const memberId = $(target).val();
    const checked = $(target).prop("checked");
    const endpoint = Routes[`${checked ? '' : 'un'}check_single_member_member_recommendation_search_index_path`];
    axios({
      method: checked ? 'post' : 'delete',
      url: endpoint(gon.locale),
      data: {
        format: gon.locale,
        member_id: memberId,
        q: { display_ignored: displayIgnored },
        searchsession: this.getSearchSessionId(),
        result_id: this.getResultId()
      }
    }).then((res) => {
      if (res.status == 200) {
        $('.js-checkbox-all').prop('checked', res.data.all_members_checked);
      }
    })
  }

  fetchAndApplyFilters(jobId) {
    clearTimeout(this.filterFetchTimeout)
    this.filterFetchTimeout = setTimeout(() => {
      this.fetchAndApplyFiltersAux(jobId)
    }, 200)
  }

  filterFetchMemo = {};

  fetchAndApplyFiltersAux(jobId) {
    jobId = Number(jobId)
    if (jobId < 1) return

    const url = Routes.fetch_saved_filters_member_recommendation_search_index_path(gon.locale, { search: { job_id: jobId } });

    this.latestFilterJobId = jobId

    this.filterFetchMemo[jobId] ||= axios.get(url)

    this.filterFetchMemo[jobId]
      .then(response => {
        if (response.data.trim() === '') return

        // This is to prevent glitches from changing too quickly.
        if (this.latestFilterJobId !== jobId) return

        const doc = (new DOMParser()).parseFromString(response.data, 'text/html')

        // From the server-rendered form, get each individual input and replace it.
        // Patching the whole form is not possible, because it includes the <form>
        // tag and other tags like table, etc.
        doc.querySelectorAll('[id][name]').forEach(element => {
          if (!element.getAttribute('name').startsWith('search[')) return

          const id = element.getAttribute('id')
          document.getElementById(id).replaceWith(element)
        })
      })
      .catch(error => console.error('Error:', error));
  }
}

export default MemberRecommendationSearch;
